import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { logout } from './auth';
import './admin.scss';

const AdminLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };
  return (
    <div className="admin-shell">
      <header className="admin-header">
        <div className="brand">Megapark Admin</div>
        <div className="spacer" />
        <button className="btn" onClick={handleLogout}>Logout</button>
      </header>
      <div className="admin-body">
        <aside className="admin-sidebar">
          <nav>
            <ul>
              <li>
                <NavLink to="/admin" end className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Yönetim Paneli (Dashboard)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/anlasmali-categories" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Anlaşmalı Kategoriler (Categories)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/anlasmali-partners" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Anlaşmalı Partnerler (Partners)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/doctor-profiles" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Doktor Profilleri (Doctor Profiles)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/companion-visitor" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}> 
                  Refakatçi & Ziyaretçi (Companion & Visitor)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/contact" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  İletişim (Contact)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/doctors" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Doktorlar (Doctors)
                </NavLink>
              </li>
              {/* <li>
                <NavLink to="/admin/doctors-grid" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Doktorlar Grid (Doctors Grid)
                </NavLink>
              </li> */}
              <li>
                <NavLink to="/admin/doctors-intro" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Doktorlar Intro (Doctors Intro)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/feature-hakkimizda" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Feature Hakkımızda
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/feature-strip" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Özellik Şeridi (Feature Strip)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/feedback-messages" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Geri Bildirim Mesajları (Feedback Messages)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/feedback-section" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Geri Bildirim Bölümü (Feedback Section)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/medical-units" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Tıbbi Birimler (Medical Units)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/tibbi-birimler" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Tıbbi Birimler
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/page-about-intro" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Hakkımızda Giriş (About Intro)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/page-doctors-hero" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Hekimler Hero (Doctors Hero)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/page-hero" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Sayfa Hero (Page Hero)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/vision-mission" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Vizyon Misyon (Vision Mission)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/visit-items" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Ziyaret Öğeleri (Visit Items)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/media" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Medya (Media)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/careers" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  İş Başvuruları (Careers)
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/ayaktan-hasta-anket" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Ayaktan Hasta Anket Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/yatan-hasta-anket" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Yatan Hasta Anket Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/acil-servis-anket" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Acil Servis Anket Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/hastane-calisanlari-gorus-oneri" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Çalışan Görüş ve Öneri Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/istenmeyen-olay" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  İstenmeyen Olay Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/sosyal-hizmet-birimi" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Sosyal Hizmet Birimi Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/duzenleyici-onleyici-faaliyet" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  DÖF Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/welcome-modal" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Welcome Modal Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/slider" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Slider Yönetimi
                </NavLink>
              </li>
              <li>
                <NavLink to="/admin/bashekim-mesaji" className={({isActive}) => `nav-link${isActive ? ' active' : ''}`}>
                  Başhekim Mesajı Yönetimi
                </NavLink>
              </li>
            </ul>
          </nav>
        </aside>
        <main className="admin-content">{children ?? <Outlet />}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
